import { FiltersPlugin, useGuiFilters } from "@me8eon/filters";
import { makeUseStateChild } from "@me8eon/context";


export const searchTextName = "searchText";

export type SearchTextFilter = {
    [searchTextName]: string
    dataview?: string
}
export const useSearchTextFilter = makeUseStateChild(useGuiFilters, lb => lb.focusOn(searchTextName));

export const searchTextFilterPlugin: FiltersPlugin<SearchTextFilter, "searchText"> = ({
    plugin: "filter",
    type: searchTextName,
    DefaultDisplay: null,
    changeCausesSubmit: false,
    deleteWhenClean: false,
    fromUrl: (debug, windowUrlData, def) => {
        const searchParams = windowUrlData.url.searchParams;
        const filter = searchParams.get(searchTextName);
        const result = filter ? filter : def;
        debug("keywordsFilter fromurl", `${searchTextName}=`, filter, result);
        return result;
    },
    addToUrl: (debug, sp: URLSearchParams, filter) => {
        debug("keywordsFilter addToUrl", `${searchTextName}=`, filter);
        if (filter) sp.set(searchTextName, filter);
        else sp.delete(searchTextName);
    },
});
